import request from '@/utils/request';
import Resource from '@/api/resource';
class NativeAnchor extends Resource {
  constructor() {
    super('tool/nativeAnchor/jrtt');
  }

  // 获取原生锚点列表
  getNativeAnchorApi(data) {
    return request({
      url: `/${this.uri}`,
      method: 'GET',
      params: data,
    });
  }

  // 同步原生锚点列表
  pullNativeAnchorApi(data) {
    return request({
      url: `/${this.uri}/pull`,
      method: 'GET',
      params: data,
    });
  }
}
export { NativeAnchor as default };
